export default "__VITE_ASSET__CoVt2eUs__"